import { SunIcon, MoonIcon, ComputerDesktopIcon, CheckIcon } from '@heroicons/react/16/solid'
import { Dropdown, DropdownButton, DropdownItem, DropdownLabel, DropdownMenu } from './Dropdown'
import { useTheme, ThemeMode } from '../context/themeContext'
import { cn } from '../lib/utils'

const OPTIONS: { mode: ThemeMode; label: string; icon: typeof SunIcon }[] = [
    { mode: 'light', label: 'Light', icon: SunIcon },
    { mode: 'dark', label: 'Dark', icon: MoonIcon },
    { mode: 'system', label: 'System', icon: ComputerDesktopIcon },
]

export function ThemeToggle() {
    const { theme, resolvedTheme, setTheme } = useTheme()
    const ActiveIcon = resolvedTheme === 'dark' ? MoonIcon : SunIcon

    return (
        <Dropdown>
            <DropdownButton plain aria-label="Theme" className="rounded-full bg-card p-2">
                <ActiveIcon className="size-5 text-muted-foreground" />
            </DropdownButton>
            <DropdownMenu className="min-w-44" anchor="bottom end">
                {OPTIONS.map(({ mode, label, icon: Icon }) => {
                    const active = theme === mode
                    return (
                        <DropdownItem
                            key={mode}
                            onClick={() => setTheme(mode)}
                            className={cn(active && 'bg-secondary dark:bg-white/5')}
                        >
                            {/* Spans every column of the shared dropdown-item grid and lays out
                                icon/label/check with plain flexbox instead - the standard
                                data-slot icon + col-start-5 check slots were landing the check
                                right next to the icon instead of at the row's far end. */}
                            <span className="col-span-full flex items-center justify-between gap-3">
                                <span className="flex items-center gap-2.5">
                                    <Icon className={cn('size-5 sm:size-4', active ? 'text-primary dark:text-white' : 'text-zinc-500 dark:text-zinc-400')} />
                                    <DropdownLabel className={cn(active && 'font-semibold text-primary dark:text-white')}>
                                        {label}
                                    </DropdownLabel>
                                </span>
                                {active && <CheckIcon className="size-4 shrink-0 text-primary dark:text-white" />}
                            </span>
                        </DropdownItem>
                    )
                })}
            </DropdownMenu>
        </Dropdown>
    )
}
